import { render, staticRenderFns } from "./SystemAlertsBell.vue?vue&type=template&id=7ca404fa&scoped=true"
import script from "./SystemAlertsBell.vue?vue&type=script&setup=true&lang=ts"
export * from "./SystemAlertsBell.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SystemAlertsBell.vue?vue&type=style&index=0&id=7ca404fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca404fa",
  null
  
)

export default component.exports